export let SubmitAction = /*#__PURE__*/function (SubmitAction) {
  SubmitAction["THANK_YOU_MESSAGE"] = "THANK_YOU_MESSAGE";
  SubmitAction["EXTERNAL_URL"] = "EXTERNAL_URL";
  return SubmitAction;
}({});
export let ExternalUrlTarget = /*#__PURE__*/function (ExternalUrlTarget) {
  ExternalUrlTarget["BLANK"] = "_blank";
  ExternalUrlTarget["SELF"] = "_self";
  return ExternalUrlTarget;
}({});
//# sourceMappingURL=submit-button-types.js.map